import exchanges from './exchanges'
import badges from './badges'

export default {
  exchanges: exchanges,
  badges: badges,

  corner: require('./corner.svg'),
  intro: require('./intro.png'),
  back: require('./back.png'),
}
